import axios from "axios";

export default axios.create({
  baseURL: 'https://saverafrica.com/wp-json/api/v2'
  // baseURL: "https://saverafrica.360southclients.com/wp-json/api/v2",
});
